/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useEffect, useRef, useState } from "react";

// Router Imports
import { useLocation, useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";

import {
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { reimbursementRequestApproval } from "../../../redux/features/reimbursementRequest/index.js";

// Utils Imports
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";

// Component Imports
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import ApprovalTopNavComponent from "../../../components/_utils/CommonTopNav/ApprovalTopNav/index.jsx";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import ReimbursementAccountDetailsPopup from "../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import Loader from "../../../components/Loader/Index";
import ReimbursementReqTxnDetailsPopup from "../../../components/ReimbursementRequest/ReimbursementReqTxnDetailsPopup/index.jsx";
import ReimbursementRequestTxnMultiCard from "../../../components/ReimbursementRequest/ReimbursementRequestMultiApproval/ReimbursementRequestTxnMultiCard/index.jsx";

const ReimbursementRequestMultiApproval = () => {
  // 1️⃣ useDispatch & Router hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptionsForUrl = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsForUrl[0],
  });

  // 2️⃣ useRef
  const filterRef = useRef(null);

  // 3️⃣ useState
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [allAccounts, setAllAccounts] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectAllCard, setselectAllCard] = useState(false);
  const [label, setlabel] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [txnlabels, settxnLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [page, setPage] = useState(
    Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [dropdownOptions] = useState(PaginationConfiguration.paginationOptions);
  const [mainData, setMainData] = useState([]);
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [approvedAccounts, setApprovedAccounts] = useState([]);
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    searchParam.get("category") || "",
  );
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") ||
      (window.innerWidth >= GlobalConfiguration.innerWidthLargeSize
        ? PaginationConfiguration.paginationMid
        : window.innerWidth >= GlobalConfiguration.innerWidthMidSize
          ? PaginationConfiguration.paginationExtraSmall
          : PaginationConfiguration.paginationSmall),
  );
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [datas, setDatas] = useState([]);

  // 4️⃣ useSelector
  const {
    beneTxnAccountData,
    BeneTxnMultiApprovalError,
    BeneTxnMultiDeniedApprovalError,
  } = useSelector((state) => state?.beneTxnViewAccData);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  // 5️⃣ Constants
  const conditionVarLengthOne = GlobalConfiguration.lengthCheckOne;
  const conditionVarLengthTwenty = GlobalConfiguration?.categorymaxLength;
  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  // 6️⃣ Callback / Handler functions
  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const fetchData = async () => {
    setLoadingData(true);

    let data = [];
    switch (active) {
      case "Category": {
        const response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data =
          response?.payload?.categories?.map((itm) => ({
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          })) ?? [];
        break;
      }
      case "Labels":
        data =
          txnlabels
            ?.filter((itm) => itm.includes(searchUserTextDebounce))
            ?.map((val) => ({ id: val, Label: val })) ?? [];
        break;
      default:
        break;
    }
    setInputData(data);
    setLoadingData(false);
  };

  // 7️⃣ useEffect
  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  const fetchTransactions = async () => {
    setAllBeneTxnAccountsLoading(true);

    try {
      let queryParams = {
        page_no: page,
        page_size: pageSize,
      };

      if (LabelSearchText?.length > GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }

      if (initCategoryFilter !== "") {
        queryParams.category = initCategoryFilter;
      }

      const response = await dispatch(
        reimbursementRequestApproval(queryParams),
      );

      const newData = response?.payload?.requests || [];
      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
      );
      setMainData(response?.payload);

      setAllAccounts(formattedData);

      const approved = newData.filter(
        (account) => account.beneficiary_account_approval_status === "approved",
      );
      setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      setMainData([]);
      setAllAccounts([]);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const onMount = () => {
    // Load labels from sessionStorage
    let availableLabels = sessionStorage?.getItem("AvailableLabelsRequest");
    if (availableLabels) {
      try {
        const parsedLabels = JSON?.parse(availableLabels);
        settxnLabels(parsedLabels || []);
      } catch (error) {
        console.error("Error parsing labels from sessionStorage:", error);
        settxnLabels([]);
      }
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError]);

  // useEffect(() => {
  //

  //   onMount();
  // }, []);

  useEffect(() => {
    fetchTransactions();
  }, [page, pageSize, initCategoryFilter, LabelSearchText, markerData]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);

    setPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return GlobalConfiguration.lengthCheckOne;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  const handleSelectAll = (tt) => {
    const alreadySelectedCount = selectedTransactions?.length;
    const remainingSelections =
      GlobalConfiguration?.categorymaxLength - alreadySelectedCount;
    if (tt) {
      let x = [];
      approvedAccounts.forEach((itm) => {
        if (selectedTransactions.includes(itm.request_id)) {
          x.push(itm.request_id);
        }
      });
      let y = selectedTransactions.filter((it) => !x.includes(it));
      let z = selectedSendTransactions.filter(
        (itm) => !x.includes(itm.request_id),
      );
      setSelectedTransactions(y);
      setSelectedSendTransactions(z);
      let amt = z.reduce(
        (sum, account) => sum + Number(account.requested_amount),
        GlobalConfiguration.lengthCheckZero,
      );
      setTotalAmount(amt);
    } else if (
      LabelSearchText?.length === GlobalConfiguration.lengthCheckZero &&
      remainingSelections === GlobalConfiguration.lengthCheckZero
    ) {
      setSelectedTransactions([]);
      setSelectedSendTransactions([]);
      setTotalAmount(GlobalConfiguration.lengthCheckZero);
    } else {
      if (remainingSelections > GlobalConfiguration.lengthCheckZero) {
        const newSelections = allAccounts
          .filter(
            (account) =>
              account.beneficiary_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.request_id),
          )
          .slice(GlobalConfiguration.lengthCheckZero, remainingSelections)
          .map((account) => account.request_id);

        const newSelectionsSend = allAccounts
          .filter(
            (account) =>
              account.beneficiary_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.request_id),
          )
          .slice(GlobalConfiguration.lengthCheckZero, remainingSelections)
          .map((account) => account);

        setSelectedTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelections,
        ]);

        setSelectedSendTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelectionsSend,
        ]);

        const newAmounts = allAccounts
          .filter((account) => newSelections.includes(account.request_id))
          .reduce(
            (sum, account) => sum + Number(account.requested_amount),
            GlobalConfiguration.lengthCheckZero,
          );

        setTotalAmount((prevAmount) => prevAmount + newAmounts);
      } else {
        let x = [];
        approvedAccounts.forEach((itm) => {
          if (selectedTransactions.includes(itm.request_id)) {
            x.push(itm.request_id);
          }
        });
        let y = selectedTransactions.filter((it) => !x.includes(it));
        let z = selectedSendTransactions.filter(
          (itm) => !x.includes(itm.request_id),
        );
        setSelectedTransactions(y);
        setSelectedSendTransactions(z);
        let amt = z.reduce(
          (sum, account) => sum + Number(account.requested_amount),
          GlobalConfiguration.lengthCheckZero,
        );
        setTotalAmount(amt);
      }
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(page) || GlobalConfiguration.lengthCheckOne;
    setPage(nextPage);
    handleSearchParams("pagesize", value);
    handleSearchParams("pageno", nextPage);
  };

  const handlePagination = (pageNum) => {
    setPage(pageNum);
    handleSearchParams("pageno", pageNum);
  };
  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handlefilter);
    return () => document.removeEventListener("click", handlefilter);
  }, []);

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  useEffect(() => {
    setDatas({
      ...datas,
      owner_account_balance_last_fetched_at_in_words:
        beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]
          ?.owner_account_balance_last_fetched_at_in_words,
      owner_account_balance:
        beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]
          ?.owner_account_balance,
      owner_account_balance_last_fetched_at:
        beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]
          ?.owner_account_balance_last_fetched_at,
    });
  }, [beneTxnAccountData]);

  const SideDrawerOpen = async (id, txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };
  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      initCategoryFilter !== "" ||
        LabelSearchText?.length > GlobalConfiguration.lengthCheckZero,
    );
  };
  useEffect(() => {
    updateIsFilterApplied();
  }, [initCategoryFilter, LabelSearchText]);
  const handleClearParams = () => {
    setInitCategoryFilter("");
    setlabel([]);
    setLabelSearchText([]);
    setPage(GlobalConfiguration.lengthCheckOne);
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${dropdownOptionsForUrl[0]}`,
      },
      { replace: true },
    );
  };
  return (
    <>
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReimbursementReqTxnDetailsPopup
            reimburse_request_id={txnId}
            closePopup={() => {
              closeBeneTxnDetailModal();
            }}
            RequestHeader={"Request details"}
            type={"reimbursereq_details"}
          />
        </div>
      )}
      {isDrawerOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReimbursementAccountDetailsPopup
            reimburse_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={"reimburseacc_details"}
          />
        </div>
      )}

      <div
        className={` bg-primary-bg flex flex-col h-screen relative overflow-hidden`}
        style={{
          background: showInnerSearchBar ? "var(--bg-PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative z-z-index-content flex flex-col overflow-y-hidden overflow-x-hidden">
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <>
              <div className="relative z-z-index-overlay">
                <ApprovalTopNavComponent
                  ispagination={shouldShowPagination}
                  handleBack={() =>
                    navigate(GlobalConfiguration.lengthCheckNegativeOne)
                  }
                  isSelectionView={true}
                  topNavHeader={totalAmount}
                  topNavSubText={"Total amount"}
                  selectionText={`Requests selected : ${selectedTransactions?.length}`}
                  selectionBtnProps={
                    !shouldShowPagination
                      ? undefined
                      : {
                          btnText: "Select up to 20",
                          btnType: "button",
                          enabledBgColor:
                            selectedTransactions?.length <
                              GlobalConfiguration?.categorymaxLength &&
                            approvedAccounts.length !==
                              GlobalConfiguration?.lengthCheckZero &&
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.request_id),
                            )
                              ? "var(--positive-bg)"
                              : selectedTransactions?.length ===
                                  GlobalConfiguration?.categorymaxLength
                                ? "var(--positive-bg)"
                                : "var(--primary-nav-act)",
                          hoverOption:
                            selectedTransactions?.length <
                              GlobalConfiguration?.categorymaxLength &&
                            approvedAccounts.length !==
                              GlobalConfiguration?.lengthCheckZero &&
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.request_id),
                            )
                              ? "black"
                              : selectedTransactions?.length ===
                                  GlobalConfiguration?.categorymaxLength
                                ? "black"
                                : "white",
                          enabledTextColor: "var(--text-primary)",
                          icon:
                            selectedTransactions?.length <
                              GlobalConfiguration?.categorymaxLength &&
                            approvedAccounts.length !==
                              GlobalConfiguration?.lengthCheckZero &&
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.request_id),
                            )
                              ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                              : selectedTransactions?.length ===
                                  conditionVarLengthTwenty
                                ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                          handleFunction: () => {
                            setselectAllCard(
                              approvedAccounts.every((itm) =>
                                selectedTransactions.includes(itm.request_id),
                              )
                                ? true
                                : selectAllCard
                                  ? false
                                  : true,
                            );
                            handleSelectAll(
                              approvedAccounts.every((itm) =>
                                selectedTransactions.includes(itm.request_id),
                              ),
                            );
                          },
                        }
                  }
                  topNavCtaBtn2Props={{
                    btnText: "Next",
                    btnType: "button",
                    enabledBgColor: "var(--text-primary)",
                    inActiveVariantNeeded: true,
                    handleFunction: () => {
                      if (
                        selectedTransactions?.length >= conditionVarLengthOne
                      ) {
                        const selectedData = {
                          selectedSendTransactions,
                          selectedTransactions,
                          timestamp: Date.now(),
                        };
                        sessionStorage.setItem(
                          "selectedReimbursementRequestTxnData",
                          JSON.stringify(selectedData),
                        );
                        navigate(
                          "/reimbursement_transaction_dashboard/reimbursement_request_multi_approval/multi_approval",
                        );
                      }
                    },
                    enabledTextColor: "var(--primary-bg)",
                    isDisabled: !selectedTransactions?.length,
                    disabledBgColor: "var(--text-disabled)",
                    disabledTextColor: "var(--text-primary)",
                  }}
                  isToggleNeeded={true}
                  toggleProps={{
                    state: false,
                    isDisabled: false,
                    title: "Single Approval",
                    handleClick: () =>
                      navigate(
                        "/reimbursement_transaction_dashboard/reimbursement_request_single_approval",
                      ),
                  }}
                  iconComponentArray={[
                    {
                      icon: "https://q2pay.in/new_assets/common/view_all/search_white.svg",
                      title: "Search",
                      hoverOption: "white",
                      isLoading: false,
                      isDisabled: allBeneTxnAccountsLoading,
                      enabledBgColor:
                        initCategoryFilter ||
                        LabelSearchText?.length >
                          GlobalConfiguration.lengthCheckZero
                          ? "var(--text-primary)"
                          : "var(--primary-bg)",
                      handleFunction: () => setShowSearchBar((prev) => !prev),
                    },
                  ]}
                  filteredSearchProps={{
                    setShowInnerSearchBar,
                    showSearchBar,
                    isSearchDisabled: allBeneTxnAccountsLoading,
                    onSearchInput: handleSearch,
                    searchText: searchUserTextDebounce,
                    searchPlaceholder: "Search request",
                    filterPlaceholder: "reimbursement name",

                    filterItems: [
                      {
                        name: "Category",
                        valueType: "string",
                        short_name: "Cat",
                        isMulti: false,
                        value: initCategoryFilter,
                        setValue: (val) => {
                          setInitCategoryFilter(val);
                          setPage(GlobalConfiguration.lengthCheckOne);
                          handleSubmit("category", val);
                        },
                        isDropdown: true,
                        isDisabled: allBeneTxnAccountsLoading,
                      },
                      {
                        name: "Labels",
                        valueType: "string",
                        short_name: "Lab",
                        isMulti: true,
                        value: label,
                        setValue: (val) => {
                          setPage(GlobalConfiguration.lengthCheckOne);
                          setlabel(val);
                          setLabelSearchText(val);
                          handleSubmit(
                            "label",
                            Array.isArray(val) ? val.join(",") : val,
                          );
                        },
                        isDropdown: true,

                        isDisabled: allBeneTxnAccountsLoading,
                      },
                    ],

                    isSearchClearAllDisabled: !(
                      initCategoryFilter?.length || LabelSearchText?.length
                    ),

                    inputData,
                    active,
                    setActive,
                    loading: loadingData,
                    setLoading: setLoadingData,
                    isShowFilter: false,
                  }}
                />
              </div>
            </>
            <div
              className={`w-width-full h-height-full bg-primary-bg overflow-y-auto flex-1  ${showInnerSearchBar && "pointer-events-none"} ${
                allAccounts?.length === GlobalConfiguration.lengthCheckZero ||
                allBeneTxnAccountsLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              }`}
            >
              {showInnerSearchBar && (
                <div
                  className={
                    "absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"
                  }
                ></div>
              )}
              {/* Main Content Area */}
              <div
                ref={filterRef}
                className="w-width-full overflow-y-auto h-[-webkit-fill-available] z-z-index-content"
                style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
              >
                {allBeneTxnAccountsLoading ? (
                  <div
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--opcacity_none)"
                        : "var(--base-opacity)",
                    }}
                    className="loader-container m-auto justify-center items-center flex h-height-full"
                  >
                    <Loader />
                  </div>
                ) : !allAccounts?.length ? (
                  <div
                    className="int-txn-mutli-no-account-found"
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--light-opacity)"
                        : "var(--base-opacity)",
                    }}
                  >
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          isFilterApplied
                            ? "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                            : "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                        }
                        className="px-padding-sm w-graphic-width-md h-graphic-square-height-md int_txn_img"
                        alt="NoData"
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account !mt-margin-sm">
                      {isFilterApplied ? (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear Parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more request that require your
                            <br />
                            approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Go to dashboard"
                              handleFunction={() =>
                                navigate("/reimbursement_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${showInnerSearchBar ? "pointer-events-none" : "flex flex-col items-center justify-center mx-auto bg-primary-bg"}`}
                  >
                    <ReimbursementRequestTxnMultiCard
                      filterOpen={showInnerSearchBar}
                      setAllAccounts={setAllAccounts}
                      data={allAccounts}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      SideDrawerOpen={SideDrawerOpen}
                      openBeneTxnDetailModal={openBeneTxnDetailModal}
                      setTxnId={setTxnId}
                      setDatas={setDatas}
                      filterRef={filterRef}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Footer Section (Pagination & Mob Next Button) */}
          <div
            className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity pointer-events-none" : "opacity-base-opacity"}`}
          >
            {shouldShowPagination ? (
              <div className="z-z-index-content w-screen">
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={page}
                  setIsOpen={(e) => {}}
                />
              </div>
            ) : null}

            {/* <div
              className="Qsmd:hidden w-width-full cursor-pointer flex justify-center items-center z-z-index-content py-padding-sm"
              style={{
                cursor:
                  selectedTransactions?.length >= conditionVarLengthOne
                    ? "pointer"
                    : "default",
                backgroundColor:
                  selectedTransactions?.length >= conditionVarLengthOne
                    ? "var(--positive-act)"
                    : "var(--text-disabled)",
                display:
                  allAccounts.length === GlobalConfiguration?.lengthCheckZero &&
                  "none",
              }}
              onClick={() => {
                if (selectedTransactions?.length >= conditionVarLengthOne) {
                  const selectedData = {
                    selectedSendTransactions,
                    selectedTransactions,
                    timestamp: Date.now(),
                  };
                  sessionStorage.setItem(
                    "selectedReimbursementRequestTxnData",
                    JSON.stringify(selectedData),
                  );
                  navigate(
                    "/reimbursement_transaction_dashboard/reimbursement_request_multi_approval/multi_approval",
                  );
                }
              }}
            >
              <p className="text-center font-semibold text-font-md text-text-primary ">
                Proceed
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReimbursementRequestMultiApproval;
